import React from 'react';
import DisclosuresText from '../DisclosuresText/DisclosuresText';
import InfoDialog from '../InfoDialog';
import { PaymentPlanEnum } from '../../configs/APISchemas/BindPolicy';

type Props = {
  open: boolean;
  onClose: () => void;
  state?: string;
  paymentType?: PaymentPlanEnum;
  annualAmountPremium?: string;
  monthlyDownPaymentAmount?: string;
  monthlyInstallment?: string;
  email: string;
}

const DisclosuresDialog = (props: Props) => {
  const {
    open,
    state,
    email,
    paymentType,
    monthlyInstallment,
    annualAmountPremium,
    monthlyDownPaymentAmount,
    onClose,
  } = props;

  return (
    <InfoDialog
      open={open}
      onClose={onClose}
      title="Disclosures"
    >
      <DisclosuresText
        state={state}
        paymentType={paymentType}
        annualAmountPremium={annualAmountPremium}
        monthlyDownPaymentAmount={monthlyDownPaymentAmount}
        monthlyInstallment={monthlyInstallment}
        email={email}
        titleProps={{ variant: 'h6' }}
        bodyProps={{ variant: 'body1' }}
      />
    </InfoDialog>
  );
};

export default DisclosuresDialog;
